import React from 'react';
import { Helmet } from 'react-helmet-async';

const ServiceSchema = ({ services = [] }) => {
  const serviceSchemas = services.map((service, index) => ({
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `https://loveyuhlife.ca/services/${service.title.toLowerCase().replace(/\s+/g, '-')}`,
    "name": service.title,
    "description": service.description,
    "provider": {
      "@type": "Organization",
      "name": "LOVEYUHLIFE INC",
      "url": "https://loveyuhlife.ca",
      "telephone": "+1-416-561-8684",
      "email": "admin@loveyuhlife.ca"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Toronto, Ontario, Canada"
    },
    "availableChannel": {
      "@type": "ServiceChannel",
      "serviceUrl": "https://loveyuhlife.ca",
      "servicePhone": "+1-416-561-8684"
    },
    "category": "Web Development Services",
    "serviceType": service.title,
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "price": "Contact for pricing",
      "priceCurrency": "CAD",
      "validFrom": "2021-01-01",
      "seller": {
        "@type": "Organization",
        "name": "LOVEYUHLIFE INC"
      }
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": `${service.title} Features`,
      "itemListElement": service.features ? service.features.map((feature, idx) => ({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": feature,
          "description": `Professional ${feature.toLowerCase()} service`
        }
      })) : []
    }
  }));

  return (
    <Helmet>
      {serviceSchemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default ServiceSchema;